export const data1_1 = [{
    name: 'Total Rooms Available 可供出租客房数',
    name_code: "Rooms_Available",
    actual: 0,//实际
    prediction: 0,//预测
    budget: 0,//预算
    last_year: 0,//去年
    actual_prediction: 0,//实际对比预测
    actual_budget: 0,//实际对比预算
    actual_last_year: 0,//实际对比去年
    year_actual: 0,//年累计 实际
    year_budget: 0,//年累计 预算
    year_last_year: 0,//年累计 去年
    year_actual_budget: 0,//年累计 实际对比预算
    year_actual_last_year: 0,//年累计 实际对比去年
    three_actual: 0,//三个月滚动预测 实际
    three_budget: 0,//三个月滚动预测 预算
    three_last_year: 0,//三个月滚动预测 去年
    three_actual_budget: 0,//三个月滚动预测 实际对比预算
    three_actual_last_year: 0,//三个月滚动预测 实际对比去年
    whole_actual: 0,//整年预测 实际
    whole_budget: 0,//整年预测 预算
    whole_last_year: 0,//整年预测 去年
    whole_actual_budget: 0,//整年预测 实际对比预算
    whole_actual_last_year: 0,//整年预测 实际对比去年
}, {
    name: 'Rooms Occupied 实际入住客房数',
    name_code: "Rooms_Occupied",
    actual: 0,
    prediction: 0,
    budget: 0,
    last_year: 0,
    actual_prediction: 0,
    actual_budget: 0,
    actual_last_year: 0,
    year_actual: 0,
    year_budget: 0,
    year_last_year: 0,
    year_actual_budget: 0,
    year_actual_last_year: 0,
    three_actual: 0,
    three_budget: 0,
    three_last_year: 0,
    three_actual_budget: 0,
    three_actual_last_year: 0,
    whole_actual: 0,
    whole_budget: 0,
    whole_last_year: 0,
    whole_actual_budget: 0,
    whole_actual_last_year: 0,
}, {
    name: 'Occupancy % 平均出租率',
    name_code: "Occupancy",
    actual: 0,
    prediction: 0,
    budget: 0,
    last_year: 0,
    actual_prediction: 0,
    actual_budget: 0,
    actual_last_year: 0,
    year_actual: 0,
    year_budget: 0,
    year_last_year: 0,
    year_actual_budget: 0,
    year_actual_last_year: 0,
    three_actual: 0,
    three_budget: 0,
    three_last_year: 0,
    three_actual_budget: 0,
    three_actual_last_year: 0,
    whole_actual: 0,
    whole_budget: 0,
    whole_last_year: 0,
    whole_actual_budget: 0,
    whole_actual_last_year: 0,
}, {
    name: 'Average Room Rate 平均房价',
    name_code: "Average_Room_Rate",
    actual: 0,
    prediction: 0,
    budget: 0,
    last_year: 0,
    actual_prediction: 0,
    actual_budget: 0,
    actual_last_year: 0,
    year_actual: 0,
    year_budget: 0,
    year_last_year: 0,
    year_actual_budget: 0,
    year_actual_last_year: 0,
    three_actual: 0,
    three_budget: 0,
    three_last_year: 0,
    three_actual_budget: 0,
    three_actual_last_year: 0,
    whole_actual: 0,
    whole_budget: 0,
    whole_last_year: 0,
    whole_actual_budget: 0,
    whole_actual_last_year: 0,
}, {
    name: 'RevPAR 每间可供出租客房收入',
    name_code: "RevPAR",
    actual: 0,
    prediction: 0,
    budget: 0,
    last_year: 0,
    actual_prediction: 0,
    actual_budget: 0,
    actual_last_year: 0,
    year_actual: 0,
    year_budget: 0,
    year_last_year: 0,
    year_actual_budget: 0,
    year_actual_last_year: 0,
    three_actual: 0,
    three_budget: 0,
    three_last_year: 0,
    three_actual_budget: 0,
    three_actual_last_year: 0,
    whole_actual: 0,
    whole_budget: 0,
    whole_last_year: 0,
    whole_actual_budget: 0,
    whole_actual_last_year: 0,
}, {
    name: 'Rooms Revenue 客房收入',
    name_code: "Rooms_Revenue",
    actual: 0,
    prediction: 0,
    budget: 0,
    last_year: 0,
    actual_prediction: 0,
    actual_budget: 0,
    actual_last_year: 0,
    year_actual: 0,
    year_budget: 0,
    year_last_year: 0,
    year_actual_budget: 0,
    year_actual_last_year: 0,
    three_actual: 0,
    three_budget: 0,
    three_last_year: 0,
    three_actual_budget: 0,
    three_actual_last_year: 0,
    whole_actual: 0,
    whole_budget: 0,
    whole_last_year: 0,
    whole_actual_budget: 0,
    whole_actual_last_year: 0,
}, {
    name: 'F&B Revenue 餐饮收入',
    name_code: "F&B_Revenue",
    actual: 0,
    prediction: 0,
    budget: 0,
    last_year: 0,
    actual_prediction: 0,
    actual_budget: 0,
    actual_last_year: 0,
    year_actual: 0,
    year_budget: 0,
    year_last_year: 0,
    year_actual_budget: 0,
    year_actual_last_year: 0,
    three_actual: 0,
    three_budget: 0,
    three_last_year: 0,
    three_actual_budget: 0,
    three_actual_last_year: 0,
    whole_actual: 0,
    whole_budget: 0,
    whole_last_year: 0,
    whole_actual_budget: 0,
    whole_actual_last_year: 0,
}, {
    name: 'Other Operated Departments 其它营运部门收入',
    name_code: "Other_Revenue",
    actual: 0,
    prediction: 0,
    budget: 0,
    last_year: 0,
    actual_prediction: 0,
    actual_budget: 0,
    actual_last_year: 0,
    year_actual: 0,
    year_budget: 0,
    year_last_year: 0,
    year_actual_budget: 0,
    year_actual_last_year: 0,
    three_actual: 0,
    three_budget: 0,
    three_last_year: 0,
    three_actual_budget: 0,
    three_actual_last_year: 0,
    whole_actual: 0,
    whole_budget: 0,
    whole_last_year: 0,
    whole_actual_budget: 0,
    whole_actual_last_year: 0,
}, {
    name: 'Total Dept. Revenue 总收入',
    name_code: "Total_Revenue",
    actual: 0,
    prediction: 0,
    budget: 0,
    last_year: 0,
    actual_prediction: 0,
    actual_budget: 0,
    actual_last_year: 0,
    year_actual: 0,
    year_budget: 0,
    year_last_year: 0,
    year_actual_budget: 0,
    year_actual_last_year: 0,
    three_actual: 0,
    three_budget: 0,
    three_last_year: 0,
    three_actual_budget: 0,
    three_actual_last_year: 0,
    whole_actual: 0,
    whole_budget: 0,
    whole_last_year: 0,
    whole_actual_budget: 0,
    whole_actual_last_year: 0,
}, {
    name: "Rooms Dept. Profit (Loss) 客房部门盈利（亏损）",
    name_code: `Rooms_Dep't_Profit`,
    actual: 0,
    prediction: 0,
    budget: 0,
    last_year: 0,
    actual_prediction: 0,
    actual_budget: 0,
    actual_last_year: 0,
    year_actual: 0,
    year_budget: 0,
    year_last_year: 0,
    year_actual_budget: 0,
    year_actual_last_year: 0,
    three_actual: 0,
    three_budget: 0,
    three_last_year: 0,
    three_actual_budget: 0,
    three_actual_last_year: 0,
    whole_actual: 0,
    whole_budget: 0,
    whole_last_year: 0,
    whole_actual_budget: 0,
    whole_actual_last_year: 0,
}, {
    name: "Rooms Dept. Profit % of Dept. Rev. 客房部门盈利（亏损）占部门收入百分比",
    name_code: `Rooms_Dep't_Profit_%`,
    actual: 0,
    prediction: 0,
    budget: 0,
    last_year: 0,
    actual_prediction: 0,
    actual_budget: 0,
    actual_last_year: 0,
    year_actual: 0,
    year_budget: 0,
    year_last_year: 0,
    year_actual_budget: 0,
    year_actual_last_year: 0,
    three_actual: 0,
    three_budget: 0,
    three_last_year: 0,
    three_actual_budget: 0,
    three_actual_last_year: 0,
    whole_actual: 0,
    whole_budget: 0,
    whole_last_year: 0,
    whole_actual_budget: 0,
    whole_actual_last_year: 0,
}, {
    name: "F&B Dept. Profit (Loss) 餐饮部门盈利（亏损）",
    name_code: `F&B_Dep't_Profit`,
    actual: 0,
    prediction: 0,
    budget: 0,
    last_year: 0,
    actual_prediction: 0,
    actual_budget: 0,
    actual_last_year: 0,
    year_actual: 0,
    year_budget: 0,
    year_last_year: 0,
    year_actual_budget: 0,
    year_actual_last_year: 0,
    three_actual: 0,
    three_budget: 0,
    three_last_year: 0,
    three_actual_budget: 0,
    three_actual_last_year: 0,
    whole_actual: 0,
    whole_budget: 0,
    whole_last_year: 0,
    whole_actual_budget: 0,
    whole_actual_last_year: 0,
}, {
    name: "F&B Dept. Profit % of Dept. Rev. 餐饮部门盈利（亏损）占部门收入百分比",
    name_code: `F&B_Dep't_Profit_%`,
    actual: 0,
    prediction: 0,
    budget: 0,
    last_year: 0,
    actual_prediction: 0,
    actual_budget: 0,
    actual_last_year: 0,
    year_actual: 0,
    year_budget: 0,
    year_last_year: 0,
    year_actual_budget: 0,
    year_actual_last_year: 0,
    three_actual: 0,
    three_budget: 0,
    three_last_year: 0,
    three_actual_budget: 0,
    three_actual_last_year: 0,
    whole_actual: 0,
    whole_budget: 0,
    whole_last_year: 0,
    whole_actual_budget: 0,
    whole_actual_last_year: 0,
}, {
    name: "Total Cost of Food and Beverage Sales 餐饮成本",
    name_code: `F&B_Total_Cost`,
    actual: 0,
    prediction: 0,
    budget: 0,
    last_year: 0,
    actual_prediction: 0,
    actual_budget: 0,
    actual_last_year: 0,
    year_actual: 0,
    year_budget: 0,
    year_last_year: 0,
    year_actual_budget: 0,
    year_actual_last_year: 0,
    three_actual: 0,
    three_budget: 0,
    three_last_year: 0,
    three_actual_budget: 0,
    three_actual_last_year: 0,
    whole_actual: 0,
    whole_budget: 0,
    whole_last_year: 0,
    whole_actual_budget: 0,
    whole_actual_last_year: 0,
}, {
    name: "Total Cost of Food and Beverage Sales % of Dept. Rev. 餐饮成本占部门收入百分比",
    name_code: `F&B_Total_Cost_%`,
    actual: 0,
    prediction: 0,
    budget: 0,
    last_year: 0,
    actual_prediction: 0,
    actual_budget: 0,
    actual_last_year: 0,
    year_actual: 0,
    year_budget: 0,
    year_last_year: 0,
    year_actual_budget: 0,
    year_actual_last_year: 0,
    three_actual: 0,
    three_budget: 0,
    three_last_year: 0,
    three_actual_budget: 0,
    three_actual_last_year: 0,
    whole_actual: 0,
    whole_budget: 0,
    whole_last_year: 0,
    whole_actual_budget: 0,
    whole_actual_last_year: 0,
}, {
    name: "Total Dept. Labor Costs and Related Expenses 所有部门总工资福利",
    name_code: `Total_Payroll_Expense`,
    actual: 0,
    prediction: 0,
    budget: 0,
    last_year: 0,
    actual_prediction: 0,
    actual_budget: 0,
    actual_last_year: 0,
    year_actual: 0,
    year_budget: 0,
    year_last_year: 0,
    year_actual_budget: 0,
    year_actual_last_year: 0,
    three_actual: 0,
    three_budget: 0,
    three_last_year: 0,
    three_actual_budget: 0,
    three_actual_last_year: 0,
    whole_actual: 0,
    whole_budget: 0,
    whole_last_year: 0,
    whole_actual_budget: 0,
    whole_actual_last_year: 0,
}, {
    name: "Total Dept. Labor Costs and Related Expenses % of Total Dept. Rev. 所有部门总工资福利占总收入百分比",
    name_code: `Total_Payroll_Expense_%`,
    actual: 0,
    prediction: 0,
    budget: 0,
    last_year: 0,
    actual_prediction: 0,
    actual_budget: 0,
    actual_last_year: 0,
    year_actual: 0,
    year_budget: 0,
    year_last_year: 0,
    year_actual_budget: 0,
    year_actual_last_year: 0,
    three_actual: 0,
    three_budget: 0,
    three_last_year: 0,
    three_actual_budget: 0,
    three_actual_last_year: 0,
    whole_actual: 0,
    whole_budget: 0,
    whole_last_year: 0,
    whole_actual_budget: 0,
    whole_actual_last_year: 0,
}, {
    name: "Utility Cost 能源成本",
    name_code: `Utility_Cost`,
    actual: 0,
    prediction: 0,
    budget: 0,
    last_year: 0,
    actual_prediction: 0,
    actual_budget: 0,
    actual_last_year: 0,
    year_actual: 0,
    year_budget: 0,
    year_last_year: 0,
    year_actual_budget: 0,
    year_actual_last_year: 0,
    three_actual: 0,
    three_budget: 0,
    three_last_year: 0,
    three_actual_budget: 0,
    three_actual_last_year: 0,
    whole_actual: 0,
    whole_budget: 0,
    whole_last_year: 0,
    whole_actual_budget: 0,
    whole_actual_last_year: 0,
}, {
    name: "Utility Cost % of Total Dept. Rev. 能源成本占总收入百分比",
    name_code: `Utility_Cost_%`,
    actual: 0,
    prediction: 0,
    budget: 0,
    last_year: 0,
    actual_prediction: 0,
    actual_budget: 0,
    actual_last_year: 0,
    year_actual: 0,
    year_budget: 0,
    year_last_year: 0,
    year_actual_budget: 0,
    year_actual_last_year: 0,
    three_actual: 0,
    three_budget: 0,
    three_last_year: 0,
    three_actual_budget: 0,
    three_actual_last_year: 0,
    whole_actual: 0,
    whole_budget: 0,
    whole_last_year: 0,
    whole_actual_budget: 0,
    whole_actual_last_year: 0,
}, {
    name: "Other Expense and Cost 其他费用及成本",
    name_code: `Other_Expense_and_Cost`,
    actual: 0,
    prediction: 0,
    budget: 0,
    last_year: 0,
    actual_prediction: 0,
    actual_budget: 0,
    actual_last_year: 0,
    year_actual: 0,
    year_budget: 0,
    year_last_year: 0,
    year_actual_budget: 0,
    year_actual_last_year: 0,
    three_actual: 0,
    three_budget: 0,
    three_last_year: 0,
    three_actual_budget: 0,
    three_actual_last_year: 0,
    whole_actual: 0,
    whole_budget: 0,
    whole_last_year: 0,
    whole_actual_budget: 0,
    whole_actual_last_year: 0,
}, {
    name: "Other Expense and Cost % 其他费用及成本率",
    name_code: `Other_Expense_and_Cost_%`,
    actual: 0,
    prediction: 0,
    budget: 0,
    last_year: 0,
    actual_prediction: 0,
    actual_budget: 0,
    actual_last_year: 0,
    year_actual: 0,
    year_budget: 0,
    year_last_year: 0,
    year_actual_budget: 0,
    year_actual_last_year: 0,
    three_actual: 0,
    three_budget: 0,
    three_last_year: 0,
    three_actual_budget: 0,
    three_actual_last_year: 0,
    whole_actual: 0,
    whole_budget: 0,
    whole_last_year: 0,
    whole_actual_budget: 0,
    whole_actual_last_year: 0,
}, {
    name: "Gross Operating Profit (Loss) 总毛利润(亏损)",
    name_code: `GOP`,
    actual: 0,
    prediction: 0,
    budget: 0,
    last_year: 0,
    actual_prediction: 0,
    actual_budget: 0,
    actual_last_year: 0,
    year_actual: 0,
    year_budget: 0,
    year_last_year: 0,
    year_actual_budget: 0,
    year_actual_last_year: 0,
    three_actual: 0,
    three_budget: 0,
    three_last_year: 0,
    three_actual_budget: 0,
    three_actual_last_year: 0,
    whole_actual: 0,
    whole_budget: 0,
    whole_last_year: 0,
    whole_actual_budget: 0,
    whole_actual_last_year: 0,
}, {
    name: "GOP % of Total Rev. 总毛利润（亏损）占总收入百分比",
    name_code: `GOP_%`,
    actual: 0,
    prediction: 0,
    budget: 0,
    last_year: 0,
    actual_prediction: 0,
    actual_budget: 0,
    actual_last_year: 0,
    year_actual: 0,
    year_budget: 0,
    year_last_year: 0,
    year_actual_budget: 0,
    year_actual_last_year: 0,
    three_actual: 0,
    three_budget: 0,
    three_last_year: 0,
    three_actual_budget: 0,
    three_actual_last_year: 0,
    whole_actual: 0,
    whole_budget: 0,
    whole_last_year: 0,
    whole_actual_budget: 0,
    whole_actual_last_year: 0,
}, {
    name: "Breakeven Point 盈亏平衡点",
    name_code: `Breakeven_Point/Total_Exp`,
    actual: 0,
    prediction: 0,
    budget: 0,
    last_year: 0,
    actual_prediction: 0,
    actual_budget: 0,
    actual_last_year: 0,
    year_actual: 0,
    year_budget: 0,
    year_last_year: 0,
    year_actual_budget: 0,
    year_actual_last_year: 0,
    three_actual: 0,
    three_budget: 0,
    three_last_year: 0,
    three_actual_budget: 0,
    three_actual_last_year: 0,
    whole_actual: 0,
    whole_budget: 0,
    whole_last_year: 0,
    whole_actual_budget: 0,
    whole_actual_last_year: 0,
}, {
    name: "Flow Thru 边际盈利率",
    name_code: `Flow_Thru`,
    actual: 0,
    prediction: 0,
    budget: 0,
    last_year: 0,
    actual_prediction: 0,
    actual_budget: 0,
    actual_last_year: 0,
    year_actual: 0,
    year_budget: 0,
    year_last_year: 0,
    year_actual_budget: 0,
    year_actual_last_year: 0,
    three_actual: 0,
    three_budget: 0,
    three_last_year: 0,
    three_actual_budget: 0,
    three_actual_last_year: 0,
    whole_actual: 0,
    whole_budget: 0,
    whole_last_year: 0,
    whole_actual_budget: 0,
    whole_actual_last_year: 0,
}, {
    name: "Base Fee 基本管理费",
    name_code: `Base_Fee`,
    actual: 0,
    prediction: 0,
    budget: 0,
    last_year: 0,
    actual_prediction: 0,
    actual_budget: 0,
    actual_last_year: 0,
    year_actual: 0,
    year_budget: 0,
    year_last_year: 0,
    year_actual_budget: 0,
    year_actual_last_year: 0,
    three_actual: 0,
    three_budget: 0,
    three_last_year: 0,
    three_actual_budget: 0,
    three_actual_last_year: 0,
    whole_actual: 0,
    whole_budget: 0,
    whole_last_year: 0,
    whole_actual_budget: 0,
    whole_actual_last_year: 0,
}, {
    name: "Brand Service Fee 品牌服务费",
    name_code: `Brand_Service_Fee`,
    actual: 0,
    prediction: 0,
    budget: 0,
    last_year: 0,
    actual_prediction: 0,
    actual_budget: 0,
    actual_last_year: 0,
    year_actual: 0,
    year_budget: 0,
    year_last_year: 0,
    year_actual_budget: 0,
    year_actual_last_year: 0,
    three_actual: 0,
    three_budget: 0,
    three_last_year: 0,
    three_actual_budget: 0,
    three_actual_last_year: 0,
    whole_actual: 0,
    whole_budget: 0,
    whole_last_year: 0,
    whole_actual_budget: 0,
    whole_actual_last_year: 0,
}, {
    name: "Incentive Fee 奖励管理费",
    name_code: `Incentive_Fee`,
    actual: 0,
    prediction: 0,
    budget: 0,
    last_year: 0,
    actual_prediction: 0,
    actual_budget: 0,
    actual_last_year: 0,
    year_actual: 0,
    year_budget: 0,
    year_last_year: 0,
    year_actual_budget: 0,
    year_actual_last_year: 0,
    three_actual: 0,
    three_budget: 0,
    three_last_year: 0,
    three_actual_budget: 0,
    three_actual_last_year: 0,
    whole_actual: 0,
    whole_budget: 0,
    whole_last_year: 0,
    whole_actual_budget: 0,
    whole_actual_last_year: 0,
}, {
    name: "Total Fee 总收费",
    name_code: `Total_Fee`,
    actual: 0,
    prediction: 0,
    budget: 0,
    last_year: 0,
    actual_prediction: 0,
    actual_budget: 0,
    actual_last_year: 0,
    year_actual: 0,
    year_budget: 0,
    year_last_year: 0,
    year_actual_budget: 0,
    year_actual_last_year: 0,
    three_actual: 0,
    three_budget: 0,
    three_last_year: 0,
    three_actual_budget: 0,
    three_actual_last_year: 0,
    whole_actual: 0,
    whole_budget: 0,
    whole_last_year: 0,
    whole_actual_budget: 0,
    whole_actual_last_year: 0,
}, {
    name: "Complimentary Room 免费房",
    name_code: `Complimentary_Room`,
    actual: 0,
    prediction: 0,
    budget: 0,
    last_year: 0,
    actual_prediction: 0,
    actual_budget: 0,
    actual_last_year: 0,
    year_actual: 0,
    year_budget: 0,
    year_last_year: 0,
    year_actual_budget: 0,
    year_actual_last_year: 0,
    three_actual: 0,
    three_budget: 0,
    three_last_year: 0,
    three_actual_budget: 0,
    three_actual_last_year: 0,
    whole_actual: 0,
    whole_budget: 0,
    whole_last_year: 0,
    whole_actual_budget: 0,
    whole_actual_last_year: 0,
}, {
    name: "House Use 自用用房",
    name_code: `House_Use`,
    actual: 0,
    prediction: 0,
    budget: 0,
    last_year: 0,
    actual_prediction: 0,
    actual_budget: 0,
    actual_last_year: 0,
    year_actual: 0,
    year_budget: 0,
    year_last_year: 0,
    year_actual_budget: 0,
    year_actual_last_year: 0,
    three_actual: 0,
    three_budget: 0,
    three_last_year: 0,
    three_actual_budget: 0,
    three_actual_last_year: 0,
    whole_actual: 0,
    whole_budget: 0,
    whole_last_year: 0,
    whole_actual_budget: 0,
    whole_actual_last_year: 0,
}, {
    name: "O-O-O Rooms 坏房",
    name_code: `O-O-O_Rooms`,
    actual: 0,
    prediction: 0,
    budget: 0,
    last_year: 0,
    actual_prediction: 0,
    actual_budget: 0,
    actual_last_year: 0,
    year_actual: 0,
    year_budget: 0,
    year_last_year: 0,
    year_actual_budget: 0,
    year_actual_last_year: 0,
    three_actual: 0,
    three_budget: 0,
    three_last_year: 0,
    three_actual_budget: 0,
    three_actual_last_year: 0,
    whole_actual: 0,
    whole_budget: 0,
    whole_last_year: 0,
    whole_actual_budget: 0,
    whole_actual_last_year: 0,
}, {
    name: "O-O-S Rooms 维护房",
    name_code: `O-O-S_Rooms`,
    actual: 0,
    prediction: 0,
    budget: 0,
    last_year: 0,
    actual_prediction: 0,
    actual_budget: 0,
    actual_last_year: 0,
    year_actual: 0,
    year_budget: 0,
    year_last_year: 0,
    year_actual_budget: 0,
    year_actual_last_year: 0,
    three_actual: 0,
    three_budget: 0,
    three_last_year: 0,
    three_actual_budget: 0,
    three_actual_last_year: 0,
    whole_actual: 0,
    whole_budget: 0,
    whole_last_year: 0,
    whole_actual_budget: 0,
    whole_actual_last_year: 0,
}]





// WEBPACK FOOTER //
// ./src/components/table/1-KPI/1-1KeyPerformanceIndicator/data.js